export function daysBetween(a, b) {
  const d1 = new Date(a + "T00:00:00");
  const d2 = new Date(b + "T00:00:00");
  return Math.round((d2 - d1) / 86400000);
}

export function nextDay(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

// When check-in changes, keep check-out at least one day after (auto-advance near the date).
export function onCheckinChange(newCheckin, currentCheckout, setForm) {
  setForm((f) => {
    const co = currentCheckout && currentCheckout > newCheckin ? currentCheckout : nextDay(newCheckin);
    return { ...f, checkin: newCheckin, checkout: co };
  });
}
